import sl_categories from './components/mp-categories';
import sl_categories_featured from './components/mp-categories-featured';
import sl_category from './components/mp-category';
import sl_category_configuration from './components/mp-category-configuration';
import sl_login from './components/mp-login';
import sl_cart from './components/mp-cart';
import sl_checkout_shipping from './components/mp-checkout-shipping';
import sl_checkout_confirmation from './components/mp-checkout-confirmation';
import sl_panel_addresses from './components/mp-panel-addresses';
import sl_panel_data from './components/mp-panel-data';
import sl_panel_orders from './components/mp-panel-orders';
import sl_incomplete_register from './components/mp-incomplete-register';
import sl_checkout_complete from './components/mp-checkout-complete';
import sl_register from './components/mp-register';
import checkout_billing from './components/mp-checkout-billing';
import sl_header from './components/mp-header';
import sl_send_art from './components/mp-send-art';
import sl_preview_art from './components/mp-preview-art';
import sl_conta_corrente from './components/mp-conta-corrente';
import sl_password_recovery from './components/mp-password-recovery';
import sl_subcategories from './components/mp-subcategories';
import sl_tkp from './components/mp-tkp';
import sl_do from './components/mp-do';
import sl_volta_aulas from './components/sl-volta-aulas';
import sl_volta_aulas_cracha from './components/sl-volta-aulas-cracha';
import sl_brindes from './components/sl-brindes';
import sl_brinde from './components/sl-brinde';
import sl_budget from './components/sl-budget';
import sl_transparent_checkout from './components/sl-transparent-checkout';

export default class Scripts {
	constructor() {
		this.components = {
			'vc_sl_categories': sl_categories,
			'vc_sl_categories_featured': sl_categories_featured,
			'vc_sl_category': sl_category,
			'vc_sl_category_configuration': sl_category_configuration,
			'vc_sl_login': sl_login,
			'vc_sl_cart': sl_cart,
			'vc_sl_checkout_shipping': sl_checkout_shipping,
			'vc_sl_checkout_confirmation': sl_checkout_confirmation,
			'vc_sl_panel_addresses': sl_panel_addresses,
			'vc_sl_panel_data': sl_panel_data,
			'vc_sl_panel_orders': sl_panel_orders,
			'vc_sl_incomplete_register': sl_incomplete_register,
			'vc_sl_checkout_complete': sl_checkout_complete,
			'vc_sl_register': sl_register,
			'vc_sl_checkout_billing': checkout_billing,
			'vc_sl_send_art': sl_send_art,
			'sl_preview_art': sl_preview_art,
			'vc_sl_panel_conta_corrente': sl_conta_corrente,
			'vc_sl_recovery_password': sl_password_recovery,
			'vc_sl_subcategories': sl_subcategories,
			'vc_sl_tkp': sl_tkp,
			'vc_sl_do': sl_do,
			'sl_volta_aulas': sl_volta_aulas,
			'sl_volta_aulas_cracha': sl_volta_aulas_cracha,
			'sl_brindes': sl_brindes,
			'sl_brinde': sl_brinde,
			'sl_transparent_checkout': sl_transparent_checkout,
			'sl_budget': sl_budget,
		};

		if ($('.sl-header').length) {
			sl_header();
		}
	}

	load(el) {
		let component = $(el).data('component');
		try	{
			this.components[component](el);
		} catch (e) {
			console.log(component);
			console.log(e);
		}
	}
}
